<h2 mat-dialog-title>
  <span class="groupIcon">
    <mat-icon>group_add</mat-icon>
  </span>
  Select & Add Participants
  <button mat-icon-button (click)="closeSelectParticipant()">
    <mat-icon>close</mat-icon>
  </button>
</h2>




<mat-dialog-content class="mat-typography">
  <mat-tab-group (selectedIndexChange)="onTabChange($event)">

    <mat-tab label="Quick Send">


      <div class="signaturePanel">

        <div class="esign">

          <div class="panel">

            <div class="groupHolder" *ngFor="let p1 of AllParticipantsProjectsList">

              <div class="example-list">

                <div class="groupheading">
                  <h2>
                    <strong>Form Name: {{p1.projectName}}</strong>
                  </h2>
                </div>

                <div *ngIf="!p1.projGrpRelationParticipantList?.length" class="moveblock example-box">
                  <p class="nocontent">No relationship added</p>
                </div>

                <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box">

                  <!-- <div class="DragIcon" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </div> -->

                  <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                    <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                  </div>

                  <div class="userInfo">
                    <div class="chipss">
                      <mat-chip-list>
                        <mat-chip> {{p.relationName}} </mat-chip>
                      </mat-chip-list>
                    </div>


                    <div class="selectContact" *ngIf="p.participantName || p.participantEmail">
                      <div class="userpic" *ngIf="p.participantImageURL">
                        <img [src]="p.participantImageURL" alt="" />
                      </div>

                      <div class="userpic" *ngIf="!p.participantImageURL">                      
                        <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                        <!-- <span class="shortName" *ngIf="p.transactionRoleName">{{getShortName(p.transactionRoleName)}}</span> -->
                        <span class="shortName" *ngIf="p.participantEmail">{{getShortName(p.participantEmail)}}</span>
                      </div>

                      <div class="info">
                        <p *ngIf="p.participantName">{{ p.participantName }} </p>                       
                        <p *ngIf="p.participantEmail">{{p.participantEmail}}</p>
                      </div>


                      <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p,p1)">
                        <mat-icon>close</mat-icon>
                      </button>

                    </div>

                    <ng-container *ngIf="!p.participantName &&  !p.participantEmail">
                      <button mat-icon-button color="primary" class="personadd"
                        (click)="assignUserNewFromQuickSend(true,false,'',p,p1)">
                        <mat-icon>person_add</mat-icon>
                      </button>
                    </ng-container>

                  </div>
                  <div class="Cancel">
                    <span class="approver" *ngIf="p.isApprover==true">Approver</span>
                  </div>

                  <div class="Cancel">
                    <span class="groups">{{p.groupName}}</span>
                  </div>

                </div>


              </div>

            </div>

          </div>
        </div>

      </div>

    </mat-tab>

    <mat-tab label="Send One by One">

      <div class="headerSection">
        <div class="totalForms">
          <span class="label">Total Forms:{{totalForms}} &nbsp;({{currentIndex + 1}} / {{totalForms}})</span>
        </div>

        <span class="label center-text">Form Name: {{placeholderName}}</span>
      </div>

      <div class="signaturePanel">

        <div class="esign">
          <div class="panel" *ngIf="participantMessageInfo!=null">
            <div class="example-list">
            </div>
            <div class="groupHolder">
              <div cdkDropList class="example-list">
                <div class="groupheading" (click)="getToogleInformation()">
                  <h2>
                    <mat-icon>message</mat-icon>Information
                  </h2>
                  <button mat-icon-button> <mat-icon>expand_more</mat-icon> </button>
                </div>

                <div id="participantMessageDiv" [ngClass]="{'active' : toogleInformation}"
                  innerHtml="{{participantMessageInfo}}"></div>

              </div>
            </div>
          </div>
          <div class="panel" cdkDropListGroup>

            <div class="groupHolder" *ngFor="let p1 of projectGroups">

              <div cdkDropList id="{{p1.groupName}}" [cdkDropListData]="p1.projGrpRelationParticipantList"
                class="example-list">

                <div class="groupheading">
                  <h2 *ngIf="p1.groupType ==1">
                    <mat-icon>create</mat-icon>{{p1.groupName}}
                  </h2>

                  <h2 *ngIf="p1.groupType !=1">
                    <mat-icon>description</mat-icon>{{p1.groupName}}
                  </h2>

                </div>

                <div *ngIf="p1.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                  <p class="nocontent">No relationship added</p>
                </div>

                <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box" cdkDrag>

                  <div class="DragIcon" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                  </div>

                  <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                    <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                    <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                  </div>

                  <div class="userInfo">
                    <div class="chipss">
                      <mat-chip-list>
                        <mat-chip> {{p.relationName}} </mat-chip>
                      </mat-chip-list>
                    </div>


                    <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                      <div class="userpic" *ngIf="p.participantImageURL">
                        <img [src]="p.participantImageURL" alt="" />
                      </div>

                      <div class="userpic" *ngIf="!p.participantImageURL">
                        <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                        <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
                        <span class="shortName" *ngIf="p.contactEmail">{{getShortName(p.contactEmail)}}</span>
                      </div>

                      <div class="info">
                        <p *ngIf="p.participantName">{{ p.participantName }} </p>

                        <p *ngIf="p.roleName">{{ p.roleName }} </p>
                        <p *ngIf="p.typeOfParticipant==0">{{p.contactEmail}}</p>
                        <p class="emailID" *ngIf="p.typeOfParticipant!=0">{{ p.participantEmail }} </p>
                      </div>


                      <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p,p1)">
                        <mat-icon>close</mat-icon>
                      </button>

                    </div>

                    <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                      <button mat-icon-button color="primary" class="personadd"
                        (click)="assignUserNew(true,false,'',p,p1)">
                        <mat-icon>person_add</mat-icon>
                      </button>
                      <!-- <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUser(addAssigne,true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button> -->
                    </ng-container>



                  </div>
                  <div class="Cancel">
                    <span class="approver" *ngIf="p.isApprover==true">Approver</span>
                  </div>

                  <!-- <ng-container *ngIf="p.selectedContactFieldEmailID.length>1">
                    <div class="partdrop">
                      <mat-form-field>
                        <mat-label>Select {{ContactNames}}</mat-label>
                        <mat-select (selectionChange)="onSelectContact($event,p.relationName,p,p1)">
                          <mat-option *ngFor="let role of p.selectedContactFieldEmailID" [value]="role.name">
                            {{role.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                  </ng-container> -->

                </div>


              </div>

            </div>

          </div>
        </div>

      </div>

    </mat-tab>


  </mat-tab-group>



</mat-dialog-content>

<mat-dialog-actions *ngIf="selectedTab==0">
  <button mat-button color="basic" (click)="closeSelectParticipant()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="SendButtonDisabledForQuickSend==true"
      (click)="QuickProjectSend()">
      Send
    </button>
</mat-dialog-actions>

<mat-dialog-actions *ngIf="selectedTab==1">
  <button mat-button color="basic" (click)="closeSelectParticipant()">Cancel</button>

  <!-- Multiple Forms Navigation -->
  <div class="navButtons" *ngIf="totalForms > 1">

    <!-- Previous -->
    <button mat-stroked-button color="primary" (click)="goToPrevious()" [disabled]="currentIndex === 0"
      matTooltip="Previous Form">
      <mat-icon>chevron_left</mat-icon>
      Previous
    </button>

    <!-- Next (hide on last page) -->
    <button *ngIf="currentIndex < totalForms - 1" mat-stroked-button color="primary" (click)="goToNext()"
      matTooltip="Next Form">
      Next
      <mat-icon>chevron_right</mat-icon>
    </button>

    <!-- Send (only on last page) -->
    <button *ngIf="currentIndex === totalForms - 1" mat-flat-button color="primary" [disabled]="!SendButtonDisabled"
      (click)="ProjectSend()">
      Send
    </button>

  </div>

  <!-- Single Form -->
  <div *ngIf="totalForms === 1">
    <button mat-flat-button color="primary" [disabled]="!SendButtonDisabled" (click)="ProjectSend()">
      Send
    </button>
  </div>

</mat-dialog-actions>